import Vue from 'vue'
import Notifications from 'vue-notification'

import App from './App'
import router from './router'

Vue.use(Notifications)
Vue.config.productionTip = false
Vue.directive('focus', {
  inserted(el) {
    el.focus()
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js